<template>
  <div v-if="list.length != 0" class="container">
    <div v-for="(item, index) in list" :key="index">
      <div v-if="item.zphdlx == '1'">
        <div class="title">{{ item.zphdmc }}</div>
        <div class="progress">
          <div class="item">
            <div
              class="header-icon"
              :class="[item.dqjd <= 5 ? 'back-blue' : 'back-gray']"
            >
              <span class="number">{{ "01" }}</span>
              <span class="">{{ "招聘报名" }}</span>
            </div>
            <div class="content">
              <!-- <div class="date">2021-01-23</div> -->
              <div class="">{{ msg(item.step_1, "bm") }}</div>
              <div class="">{{ msg(item.step_1, "dw") }}</div>
              <div class="">{{ msg(item.step_1, "gw") }}</div>
            </div>
          </div>
          <div class="item">
            <div
              class="header-icon"
              :class="[
                item.dqjd > 1 && item.dqjd <= 5 ? 'back-blue' : 'back-gray',
              ]"
            >
              <span class="number">{{ "02" }}</span>
              <span class="">{{ "报名审核" }}</span>
            </div>
            <div class="content">
              <!-- <div class="date">2021-01-25</div> -->
              <div class="">{{ item.step_2 }}</div>
              <div
                v-if="item.sfqrcjbs == '1'"
                :class="{ success: true, danger: false }"
              >
                您已确认参加笔试
              </div>
              <div
                v-if="item.sfqrcjbs !== '1' && item.shjg == '1'"
                :class="{ success: false, danger: true }"
              >
                未确认参加笔试
              </div>
              <div
                @click="getMsg(item.zphdid)"
                v-if="item.sfqrcjbs == '1'"
                class="link"
              >
                查看笔试通知
              </div>
              <div v-if="item.sfqrcjbs !== '1' && item.shjg == '1'" class="">
                <el-button
                  type="primary"
                  size="small"
                  @click="confirmWritten(item)"
                  >确认参加笔试</el-button
                >
              </div>
            </div>
          </div>
          <div class="item">
            <div
              class="header-icon"
              :class="[
                item.dqjd > 2 && item.dqjd <= 5 ? 'back-blue' : 'back-gray',
              ]"
            >
              <span class="number">{{ "03" }}</span>
              <span class="">{{ "参加笔试" }}</span>
            </div>
            <div class="content" v-if="true">
              <!-- <div class="date">2021-01-26</div> -->
              <div class="">{{ item.step_3 }}</div>
              <div
                v-if="item.sfqrcjms == '1'"
                :class="{ success: true, danger: false }"
              >
                您已确认参加面试
              </div>
              <div
                v-if="item.sfqrcjms !== '1' && item.bsjg == '1'"
                :class="{ success: false, danger: true }"
              >
                未确认参加面试
              </div>
              <div class="" v-if="item.bsjg !== ''">
                <el-button
                  type="primary"
                  size="small"
                  @click="writtenScore(item)"
                  >查询笔试成绩</el-button
                >
              </div>
            </div>
          </div>
          <div class="item">
            <div
              class="header-icon"
              :class="[
                item.dqjd > 3 && item.dqjd <= 5 ? 'back-blue' : 'back-gray',
              ]"
            >
              <span class="number">{{ "04" }}</span>
              <span class="">{{ "参加面试" }}</span>
            </div>
            <div class="content">
              <!-- <div class="date">2021-01-29</div> -->
              <div class="">{{ item.step_4 }}</div>
              <div
                v-if="item.sfqrcjms == '1'"
                @click="toInterviewMsg(item.zphdid)"
                class="link"
              >
                查看面试通知
              </div>
              <div v-if="item.sfqrcjms == '1'" class="">
                <el-button
                  type="primary"
                  size="small"
                  @click="interviewScore(item)"
                  >查询面试成绩</el-button
                >
              </div>
            </div>
          </div>
          <div class="item">
            <div
              class="header-icon"
              :class="[item.dqjd == 5 ? 'back-blue' : 'back-gray']"
            >
              <span class="number">{{ "05" }}</span>
              <span class="">{{ "录取结果查询" }}</span>
            </div>
            <div class="content" v-if="true">
              <!-- <div class="date">2021-02-23</div> -->
              <div class="">{{ item.step_5 }}</div>
              <div class=""></div>
              <div class="">
                <el-button
                  v-if="item.sfqdwkcdx !== ''"
                  type="primary"
                  size="small"
                  @click="zhScore(item)"
                  >查询综合成绩</el-button
                >
              </div>
            </div>
            <div class="none" v-if="false">
              <div>暂无成绩</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="item.zphdlx == '2'">
        <div class="title">{{ item.zphdmc }}</div>
        <div class="progress">
          <div class="item">
            <div
              class="header-icon"
              :class="[item.dqjd <= 5 ? 'back-blue' : 'back-gray']"
            >
              <span class="number">{{ "01" }}</span>
              <span class="">{{ "招聘报名" }}</span>
            </div>
            <div class="content">
              <!-- <div class="date">2021-01-23</div> -->
              <div class="">{{ msg(item.step_1, "bm") }}</div>
              <div class="">{{ msg(item.step_1, "dw") }}</div>
              <div class="link">{{ msg(item.step_1, "gw") }}</div>
            </div>
          </div>
          <div class="item">
            <div
              class="header-icon"
              :class="[
                item.dqjd > 1 && item.dqjd <= 5 ? 'back-blue' : 'back-gray',
              ]"
            >
              <span class="number">{{ "02" }}</span>
              <span class="">{{ "录取结果" }}</span>
            </div>
            <div class="content">
              <!-- <div class="date">2021-01-25</div> -->
              <div class="">{{ item.step_2 }}</div>
              <div
                @click="goReportInfomation(item.zphdid)"
                v-if="item.qyzt == '1'"
                class="link"
              >
                查看报道通知
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.none {
  color: #999999;
  min-height: 196px;
  border-left: 1px solid #dcdcdc;
  display: flex;
  justify-content: center;
  align-items: center;
}
.success {
  color: #27c18c;
}
.danger {
  color: #ff5858;
}
.link {
  color: #2a8ae0;
  &:hover {
    cursor: pointer;
  }
}
.back-blue {
  background-image: url("../../../assets/image/jobProgress/blue_left.svg"),
    url("../../../assets/image/jobProgress/blue_right.svg");
  color: #ffffff;
}
.back-gray {
  background-image: url("../../../assets/image/jobProgress/gray_left.svg"),
    url("../../../assets/image/jobProgress/gray_right.svg");
  color: #666666;
}
.container {
  padding: 10px;

  .title {
    font-weight: bold;
    margin: 10px 0px;
  }
  .progress {
    display: flex;
    flex-direction: row;
    .item {
      display: flex;
      flex-direction: column;
      width: 20%;
      .header-icon {
        padding: 10px 20px;
        font-weight: bold;
        background-repeat: no-repeat no-repeat;
        background-size: contain contain;
        background-position-y: center;
        .number {
          margin-right: 30px;
        }
      }
      .content {
        padding-left: 20px;
        font-size: 12px;
        border-left: 1px solid #dcdcdc;
        div {
          padding: 10px 0px;
          min-height: 16px;
          &:nth-child(5) {
            min-height: 32px;
          }
          &.date {
            color: #999999;
          }
        }
      }
      &:nth-child(1) .content {
        border-left: 0px;
      }
    }
  }
}
</style>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headerList: ["招聘报名", "报名审核", "参加笔试", "参加面试", "成绩查询"],
      item: [],
    };
  },
  watch: {
    list(val) {
      this.item = val;
      console.log(val);
    },
  },
  computed: {
    msg() {
      return (a, b) => {
        if (b == "bm") {
          return a.split(";")[0];
        } else if (b == "dw") {
          return a.split(";")[1];
        } else {
          return a.split(";")[2];
        }
      };
    },
  },
  mounted() {},
  methods: {
    confirmWritten(item) {
      this.$router.push({
        name: "ConfirmWritten",
        params: {
          data: JSON.stringify(item),
        },
      });
    },
    writtenScore(item) {
      this.$router.push({
        name: "WrittenScore",
        params: {
          data: JSON.stringify(item),
        },
      });
    },
    interviewScore(item) {
      this.$router.push({
        name: "InterviewScore",
        params: {
          data: JSON.stringify(item),
        },
      });
    },
    /* 综合成绩查询 */
    zhScore(item) {
      this.$router.push({
        name: "ZhScore",
        params: {
          data: JSON.stringify(item),
        },
      });
    },
    /**
     * 查看报到通知
     */
    goReportInfomation(id) {
      this.$router.push({
        path: "/reportInfomation",
        query: {
          id: id,
        },
      });
    },
    /* 查看笔试通知 */
    getMsg(id) {
      this.$router.push({
        path: "/msg",
        query: {
          id: id,
        },
      });
    },
    /* 查看面试通知 */
    toInterviewMsg(id) {
      this.$router.push({
        path: "/interviewMsg",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
